import {
    matchElementHeight
} from '../global/_matchElementHeight';
import {
    nextDayChecked
} from './_nextDayChecked';
import {
    billingSameAsShipping
} from './_billingSameAsShipping';
import {
    qcProfileCardInfoChange
} from './_qcProfileCardInfoChange';
import {
	validateCardInfo
} from '../../utils/_paymentValidator';

export const setupQuickCheckout = () => {
    if ($('#quickCheckoutForm').length > 0) {
        matchElementHeight('.account-block, .address-block', true, true);
        qcProfileCardInfoChange();
        nextDayChecked();
        billingSameAsShipping();
        validateCardInfo();
    }
};
